export default __webpack_public_path__ + "static/media/lorcanaLogo.f7b5bbf5.png";